/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { TFunction } from 'i18next'
import { TableViewId } from 'types/enums/specific/TableViewId'

const COLUMN_LABEL_KEYS: Record<string, string> = {
    name: 'Name',
    subject: 'Subject',
    contact: 'Contact',
    company: 'Company',
    account: 'Account',
    address: 'Address',
    category: 'Category',
    status: 'Status',
    tags: 'Tags',
    source: 'Source',
    content: 'Content',
    date: 'Date',
    email: 'Email',
    entity: 'Entity',
    gender: 'Gender',
    leads: 'Leads',
    offers: 'Offers',
    opportunities: 'Opportunities',
    origin: 'Origin',
    persons: 'Persons',
    phone: 'Phone',
    position: 'Position',
    reminders: 'Reminders',
    reservations: 'Reservations',
    time: 'Time',
    title: 'Title',
    total: 'Total',
    town: 'Town',
    type: 'Type',
    value: 'Value',
    website: 'Website',
    id: 'ID',
    created_date: 'Created Date',
    closed_at: 'Closed Date',
    created_at: 'Created at',
    updated_at: 'Updated at',
    persons_reserved: 'Reserved participants',
    persons_effective: 'Effective participants',
    seller_id: 'Created by',
    company_id: 'Company',
    company_name: 'Company',
    company_type: 'Account Type',
    'company.type': 'Account Type',
    company_branche: 'Industry',
    company_state: 'Kanton',
    region: 'Region',
    company_address: 'Address',
    contact_position: 'Position',
    contact_gender: 'Gender',
    offer_number: 'Offer #',
    package: 'Package',
    duration_breakdown: 'Stay',
    event_time: 'Time',
    has_reservation: 'Reservation',
    valid_until: 'Valid until',
    calculations_count: 'Calculations',
    lifecycle_status: 'Lifecycle',
    business_category: 'Industry',
    employee_size: 'Employee size',
    employee_count: 'Employee count',
    postal_code: 'ZIP',
    street_name: 'Street',
    reminder_type: 'Type',
    due_at: 'Due',
    total_invoice: 'Effective revenue',
    potential_value: 'Potential value',
    requested_date: 'Requested date',
}

const humanizeColumnId = (columnId: string): string =>
    columnId
        .replace(/[._]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/^\w/, (character) => character.toUpperCase())

export const getTableColumnLabel = (columnId: string, t: TFunction, tableId?: string): string => {
    const labelKey = columnId === 'potential_value' && tableId === TableViewId.Opportunities
        ? 'Reservierter Umsatz'
        : COLUMN_LABEL_KEYS[columnId]
    if (labelKey) {
        return t(labelKey)
    }

    // Unknown identifiers are display fallbacks, not translation keys.
    return humanizeColumnId(columnId)
}
